import { euUdiVersionsEudamedXmlServices } from '../Products/EudamedXmlServices.js'

// Regions of the UDIs table. A new country also needs its entity type, field resolvers and repository query in the backend.
export const UDI_REGIONS = [
    {
        value: "EU",
        label: "EU UDIs",
        entityType: "product-udis-eu",
        entityTypeId: 16,
        dataUrl: "/umbraco/api/RIMSProducts/EUUDIs",
        countUrl: "/umbraco/api/RIMSProducts/EUUDICount",
        eudamedXmlServices: euUdiVersionsEudamedXmlServices,
        productUdiTab: "eu",
        // Rows are EU UDI versions (row Id = version id)
        hasVersions: true,
    },
    {
        value: "US",
        label: "US UDIs",
        entityType: "product-udis-us",
        entityTypeId: 17,
        dataUrl: "/umbraco/api/RIMSProducts/USUDIs",
        countUrl: "/umbraco/api/RIMSProducts/USUDICount",
        eudamedXmlServices: [],
        productUdiTab: "us",
    },
];

export const getUdiRegionByEntityType = (entityType) => UDI_REGIONS.find(region => region.entityType === entityType);
